import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteEventListLayer from "../components/WebsiteEventListLayer";

const WebsiteEventListPage = () => {
    return (
        <MasterLayout>
            <WebsiteEventListLayer />
        </MasterLayout>
    );
};

export default WebsiteEventListPage;
